import { render, staticRenderFns } from "./ContactsPhoneList.vue?vue&type=template&id=ec35c59c"
import script from "./ContactsPhoneList.vue?vue&type=script&lang=js"
export * from "./ContactsPhoneList.vue?vue&type=script&lang=js"
import style0 from "./ContactsPhoneList.vue?vue&type=style&index=0&id=ec35c59c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports